"use client";

import { useRouter, usePathname } from "next/navigation";

const AUTH_PATHS = ["/login", "/register"] as const;

interface UseAuthModalReturn {
  openLogin: (redirect?: string) => void;
  openRegister: (redirect?: string) => void;
  close: () => void;
}

function buildAuthUrl(
  path: string,
  redirect: string | undefined,
  currentPath: string
): string {
  const redirectParam = redirect ?? currentPath;
  if (AUTH_PATHS.includes(redirectParam as (typeof AUTH_PATHS)[number])) {
    return path;
  }
  return `${path}?redirect=${encodeURIComponent(redirectParam)}`;
}

export function useAuthModal(): UseAuthModalReturn {
  const router = useRouter();
  const pathname = usePathname();

  const openLogin = (redirect?: string) => {
    router.push(buildAuthUrl("/login", redirect, pathname));
  };

  // Both login and register open the same /login intercepted route.
  // The modal contains tabs for both login and register views.
  const openRegister = (redirect?: string) => {
    router.push(buildAuthUrl("/login", redirect, pathname));
  };

  const close = () => {
    // router.back() closes the intercepted route modal and returns to the background page
    router.back();
  };

  return { openLogin, openRegister, close };
}
